<template>
  <div>
    <a-layout id="components-layout-demo-custom-trigger">
      <a-table
        :style="{background:'#fff'}"
        :columns="columns"
        :pagination="false"
        :dataSource="campaigns.data"
        :rowKey="data => data.id"
        :bordered="false"
      >
        <router-link
          slot="name"
          slot-scope="text, rowData"
          :to="{ name: 'sites.campaign.overview', params: { campaignId: rowData.id }}"
        >{{text}}</router-link>
      </a-table>

      <div class="pagination" style="font-weight: normal; text-align: end; padding-top: 20px; background: #fafafa;" v-if="campaigns.meta">
        <span>total {{ campaigns.meta.total }} items</span>
        <span style="margin-left: 15px; margin-right: 15px; color: #cecece;">|</span>
        <span>page {{ campaigns.meta.current_page }} of {{ campaigns.meta.last_page }}</span>
        <span style="margin-left: 15px; margin-right: 15px; color: #cecece;" v-if="campaigns.meta.last_page > 1">|</span>
        <a :disabled="campaigns.meta.current_page == 1"
            style="margin-right: 10px;"
            class="pagination--btn"
            @click.prevent="paginate(campaigns.meta.current_page - 1)"
            v-if="campaigns.meta.last_page > 1"
        >&lt; Previous</a>
        <a
            :disabled="campaigns.meta.current_page == campaigns.meta.last_page"
            class="pagination--btn"
            @click.prevent="paginate(campaigns.meta.current_page + 1)"
            v-if="campaigns.meta.last_page > 1"
        >Next &gt;</a>
      </div>

    </a-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status"
        },
        {
          title: "Lists",
          dataIndex: "lists[0].name",
          key: "lists[0].name"
        },
        {
          title: "Sent",
          dataIndex: "sent",
          key: "sent"
        },
        {
          title: "Open",
          dataIndex: "opened",
          key: "open"
        },
        {
          title: "Click",
          dataIndex: "clicked",
          key: "click"
        },
        {
          title: "Unsub",
          dataIndex: "unsubscribed",
          key: "unsubscribed"
        },
        {
          title: "Created At",
          dataIndex: "created_at",
          key: "created_at"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      campaigns: "sites/campaigns"
    })
  },
  methods: {
    ...mapActions({
      getCampaigns: "sites/GET_CAMPAIGNS"
    }),

    paginate(page) {
      this.$store.commit("sites/GET_CAMPAIGNS", { site: this.$route.params.siteId, page: page });
    },
  },
  created() {
    this.$store.commit("sites/GET_CAMPAIGNS", { site: this.$route.params.siteId });
  }
};
</script>

<style scoped>
  .pagination--btn {
    background-color: #e5e5e5;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px 9px;
    line-height: 1.8;
  }
</style>
